import { render, staticRenderFns } from "./orders-partial.vue?vue&type=template&id=991962ee"
import script from "./orders-partial.vue?vue&type=script&lang=js"
export * from "./orders-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports